import { Component } from '@angular/core';
import { BasicService } from 'src/service/basic.service';
import { ConnectivityService } from 'src/service/connectivity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public basicService: BasicService,
    public connectivity: ConnectivityService
  ) {}
}
